import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Login.css";
import logo from "../../img/logos/logo-btk.svg";
import { useAuth } from "../../Shared/Auth/AuthContext";
import { IconAlerta } from "../../Shared/Icons/Icons";

const EMAIL_VALIDO = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validar({ email, senha }) {
  const erros = {};

  if (!email.trim()) {
    erros.email = "Informe o seu e-mail.";
  } else if (!EMAIL_VALIDO.test(email.trim())) {
    erros.email = "Informe um e-mail válido, como nome@empresa.com.br.";
  }

  if (!senha) {
    erros.senha = "Informe a sua senha.";
  }

  return erros;
}

function MensagemErro({ id, children }) {
  return (
    <p id={id} className="field-error">
      <IconAlerta size={16} />
      {children}
    </p>
  );
}

export default function Login() {
  const { entrar } = useAuth();
  const { state } = useLocation();
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erros, setErros] = useState({});
  const [erroApi, setErroApi] = useState("");
  const [entrando, setEntrando] = useState(false);
  const emailRef = useRef(null);
  const senhaRef = useRef(null);

  const sessaoExpirada = state?.motivo === "expirada" && !erroApi;

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (erros.email) setErros((atuais) => ({ ...atuais, email: undefined }));
  };

  const handleSenhaChange = (e) => {
    setSenha(e.target.value);
    if (erros.senha) setErros((atuais) => ({ ...atuais, senha: undefined }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (entrando) return;

    const novosErros = validar({ email, senha });
    setErros(novosErros);
    setErroApi("");

    if (novosErros.email) {
      emailRef.current?.focus();
      return;
    }
    if (novosErros.senha) {
      senhaRef.current?.focus();
      return;
    }

    setEntrando(true);
    try {
      // Com a sessao aberta, a RotaPublica leva para a tela de origem.
      await entrar({ email, senha });
    } catch (error) {
      setErroApi(error.message);
      if (error.tipo === "credenciais") {
        setSenha("");
        senhaRef.current?.focus();
      }
      setEntrando(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-conteudo">
        <img className="login-logo" src={logo} alt="BTK Solutions" />

        <form
          className="card login-card"
          onSubmit={handleSubmit}
          noValidate
          aria-labelledby="login-titulo"
        >
          <div className="login-cabecalho">
            <h1 id="login-titulo" className="login-titulo">
              Entrar no ERP
            </h1>
            <p className="login-subtitulo">
              Use o e-mail e a senha da sua conta BTK.
            </p>
          </div>

          {sessaoExpirada && (
            <div className="alert login-aviso" role="status">
              <IconAlerta size={18} />
              <span>Sua sessão expirou. Entre novamente para continuar.</span>
            </div>
          )}

          {erroApi && (
            <div className="alert alert-error" role="alert">
              <IconAlerta size={18} />
              <span>{erroApi}</span>
            </div>
          )}

          <div className="field">
            <label htmlFor="login-email" className="field-label">
              E-mail
            </label>
            <input
              ref={emailRef}
              id="login-email"
              type="email"
              inputMode="email"
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              className="field-input"
              placeholder="nome@empresa.com.br"
              value={email}
              onChange={handleEmailChange}
              aria-invalid={Boolean(erros.email)}
              aria-describedby={erros.email ? "login-email-erro" : undefined}
            />
            {erros.email && (
              <MensagemErro id="login-email-erro">{erros.email}</MensagemErro>
            )}
          </div>

          <div className="field">
            <label htmlFor="login-senha" className="field-label">
              Senha
            </label>
            <input
              ref={senhaRef}
              id="login-senha"
              type="password"
              autoComplete="current-password"
              className="field-input"
              value={senha}
              onChange={handleSenhaChange}
              aria-invalid={Boolean(erros.senha)}
              aria-describedby={erros.senha ? "login-senha-erro" : undefined}
            />
            {erros.senha && (
              <MensagemErro id="login-senha-erro">{erros.senha}</MensagemErro>
            )}
          </div>

          <button
            type="submit"
            className="btn btn-primary login-botao"
            disabled={entrando}
            aria-busy={entrando}
          >
            {entrando && <span className="spinner" aria-hidden="true" />}
            {entrando ? "Entrando…" : "Entrar"}
          </button>
        </form>
      </div>
    </main>
  );
}
